/**
 * Arabic translations of backend response messages, keyed by the exact
 * English text the backend sends (CustomError / success messages).
 * Single source of truth for FE and BE localization — the frontend loads
 * this as the i18next 'backend' namespace; unknown messages pass through.
 */
export const backendMessagesAr: Record<string, string> = {
  '(#133010) Account not registered': '(#133010) الحساب غير مسجَّل',
  '2FA has been successfully disabled for your account.':
    'تم تعطيل المصادقة الثنائية (2FA) لحسابك بنجاح.',
  '2FA has been successfully enabled for your account.':
    'تم تفعيل المصادقة الثنائية (2FA) لحسابك بنجاح.',
  '2FA is already enabled for this user':
    'المصادقة الثنائية (2FA) مفعَّلة بالفعل لهذا المستخدم',
  '2FA is not enabled for this user':
    'المصادقة الثنائية (2FA) غير مفعَّلة لهذا المستخدم',
  '2FA not configured correctly':
    'لم يتم إعداد المصادقة الثنائية (2FA) بشكل صحيح',
  '2FA setup initiated. Please verify to complete setup.':
    'بدأ إعداد المصادقة الثنائية (2FA). يرجى التحقق لإكمال الإعداد.',
  '2FA setup not found. Please initiate 2FA setup first.':
    'لم يتم العثور على إعداد المصادقة الثنائية (2FA). يرجى بدء إعداد المصادقة الثنائية أولاً.',
  '2FA status retrieved successfully.':
    'تم استرداد حالة المصادقة الثنائية (2FA) بنجاح.',
  '2FA token required': 'رمز المصادقة الثنائية (2FA) مطلوب',
  'A contact book entry is identified by the WhatsApp user ID of the contact, for example BD.1068713429041673.':
    'يتم تعريف إدخال دفتر جهات الاتصال بمعرّف مستخدم واتساب الخاص بجهة الاتصال، مثال BD.1068713429041673.',
  'A positive "take" value (limit) is required for pagination.':
    'يلزم توفير قيمة موجبة للمعامل "take" (الحد) لترقيم الصفحات.',
  'A valid business must be present in the request token to attach credit line':
    'يجب وجود نشاط تجاري صالح في رمز الطلب لربط خط الائتمان',
  'AI results retrieved successfully':
    'تم استرداد نتائج الذكاء الاصطناعي بنجاح',
  'month is required in YYYY-MM format, e.g. 2026-09':
    'يجب تحديد month بتنسيق YYYY-MM، مثال 2026-09',
  'API key added successfully': 'تمت إضافة مفتاح API بنجاح',
  'API key deleted successfully': 'تم حذف مفتاح API بنجاح',
  'API key has been revoked': 'تم إبطال مفتاح API',
  'API key not found': 'لم يتم العثور على مفتاح API',
  'API key revoked successfully': 'تم إبطال مفتاح API بنجاح',
  'API keys retrieved successfully': 'تم استرداد مفاتيح API بنجاح',
  'Access Token not found': 'لم يتم العثور على رمز الوصول',
  'Access Token not valid': 'رمز الوصول غير صالح',
  'Access denied': 'تم رفض الوصول',
  'Access denied. VPC only.': 'تم رفض الوصول. VPC فقط.',
  'Account already exists': 'الحساب موجود بالفعل',
  'Analytics data is temporarily unavailable, please try again shortly':
    'بيانات التحليلات غير متوفرة مؤقتًا، يرجى المحاولة مرة أخرى بعد قليل',
  'Active API key set successfully': 'تم تعيين مفتاح API النشط بنجاح',
  'Active bots retrieved successfully': 'تم استرداد الروبوتات النشطة بنجاح',
  'Active call already exists for this client':
    'توجد مكالمة نشطة بالفعل لهذا العميل',
  'An update is already in progress for this function. Please wait a moment and try again.':
    'هناك تحديث قيد التنفيذ بالفعل لهذه الدالة. يرجى الانتظار قليلاً ثم المحاولة مرة أخرى.',
  'App not found!': 'لم يتم العثور على التطبيق!',
  'At least one of subject, description, or profile picture file is required':
    'يلزم توفير واحد على الأقل من: الموضوع أو الوصف أو ملف صورة الملف الشخصي',
  'At least one of tags or attributes must be provided':
    'يجب توفير واحد على الأقل من الوسوم أو السمات',
  'Copilot chats are tied to a signed-in user and are not available to API keys.':
    'محادثات Copilot مرتبطة بمستخدم مسجَّل الدخول وغير متاحة لمفاتيح API.',
  'Invalid session id': 'معرّف الجلسة غير صالح',
  'This chat has newer messages on another device. Reload to catch up before saving.':
    'تحتوي هذه المحادثة على رسائل أحدث على جهاز آخر. أعد التحميل للاطلاع على آخر التحديثات قبل الحفظ.',
  'audio file is required': 'ملف الصوت مطلوب',
  Transcribed: 'تم التفريغ النصي',
  'Transcription failed': 'فشل التفريغ النصي',
  'Authenticated email missing': 'البريد الإلكتروني المصادَق عليه مفقود',
  'Authentication required.': 'المصادقة مطلوبة.',
  'Authorization header is required.': 'ترويسة Authorization مطلوبة.',
  "Authorization header must be formatted as 'Bearer [token]'.":
    "يجب أن تكون ترويسة Authorization بالتنسيق 'Bearer [token]'.",
  'Authorization successful.': 'تم التفويض بنجاح.',
  'Balance added successfully': 'تمت إضافة الرصيد بنجاح',
  'before and beforeId must each be a single value':
    'يجب أن يكون كل من before وbeforeId قيمة واحدة',
  'before must be a valid ISO timestamp':
    'يجب أن يكون before طابعًا زمنيًا صالحًا بتنسيق ISO',
  'beforeId must be sent together with before':
    'يجب إرسال beforeId مع before معًا',
  'Bill ID is required.': 'معرّف الفاتورة مطلوب.',
  'Bill deleted successfully.': 'تم حذف الفاتورة بنجاح.',
  'Bill fetched successfully.': 'تم جلب الفاتورة بنجاح.',
  'Bill not found.': 'لم يتم العثور على الفاتورة.',
  'Bill updated successfully.': 'تم تحديث الفاتورة بنجاح.',
  'Billing data generated successfully.': 'تم إنشاء بيانات الفوترة بنجاح.',
  'Bills fetched successfully.': 'تم جلب الفواتير بنجاح.',
  'Blocked clients fetched successfully': 'تم جلب العملاء المحظورين بنجاح',
  'Books mapping fetched.': 'تم جلب ربط Books.',
  'Books mapping is not enabled for this business.':
    'ربط Books غير مفعَّل لهذا النشاط التجاري.',
  'Books mapping updated.': 'تم تحديث ربط Books.',
  'Bot results retrieved successfully': 'تم استرداد نتائج الروبوت بنجاح',
  'Business Account ID or FB Access Token is missing!':
    'معرّف حساب النشاط التجاري أو رمز وصول FB مفقود!',
  'Business has no Meta access token configured':
    'لا يوجد رمز وصول Meta مُعدّ للنشاط التجاري',
  'Business has no WhatsApp phone number configured':
    'لا يوجد رقم هاتف WhatsApp مُعدّ للنشاط التجاري',
  'Business ID is required': 'معرّف النشاط التجاري مطلوب',
  'Business WhatsApp credentials not configured':
    'لم يتم إعداد بيانات اعتماد WhatsApp للنشاط التجاري',
  'Business deleted successfully!': 'تم حذف النشاط التجاري بنجاح!',
  'Business details are missing. Please add business details first!':
    'تفاصيل النشاط التجاري مفقودة. يرجى إضافة تفاصيل النشاط التجاري أولاً!',
  'Business details are missing. Please add business details first.':
    'تفاصيل النشاط التجاري مفقودة. يرجى إضافة تفاصيل النشاط التجاري أولاً.',
  'Business details are missing. Please complete WhatsApp setup first.':
    'تفاصيل النشاط التجاري مفقودة. يرجى إكمال إعداد WhatsApp أولاً.',
  'Business details are missing. So please add first business details!':
    'تفاصيل النشاط التجاري مفقودة. لذا يرجى إضافة تفاصيل النشاط التجاري أولاً!',
  'Business does not have a Facebook Access Token.':
    'لا يمتلك النشاط التجاري رمز وصول Facebook.',
  'Business does not have a Facebook App ID. So please add Facebook App ID in WhatsApp API Setup!':
    'لا يمتلك النشاط التجاري معرّف تطبيق Facebook. لذا يرجى إضافة معرّف تطبيق Facebook في إعداد WhatsApp API!',
  'Business has no orgId': 'لا يوجد orgId للنشاط التجاري',
  'Business name updated successfully!': 'تم تحديث اسم النشاط التجاري بنجاح!',
  'Business not found': 'لم يتم العثور على النشاط التجاري',
  'Business not found in your organization.':
    'لم يتم العثور على النشاط التجاري في مؤسستك.',
  'Business not found or does not belong to this organization':
    'لم يتم العثور على النشاط التجاري أو أنه لا ينتمي إلى هذه المؤسسة',
  'Business not found or does not belong to this partner.':
    'لم يتم العثور على النشاط التجاري أو أنه لا ينتمي إلى هذا الشريك.',
  'Business not found!': 'لم يتم العثور على النشاط التجاري!',
  'Business not found.': 'لم يتم العثور على النشاط التجاري.',
  'Business phone number is not configured correctly':
    'لم يتم إعداد رقم هاتف النشاط التجاري بشكل صحيح',
  'Business setup correctly not found':
    'لم يتم العثور على إعداد صحيح للنشاط التجاري',
  'Business setup is incomplete': 'إعداد النشاط التجاري غير مكتمل',
  'Business setup is incomplete. Missing fbAccessToken or businessAccountId.':
    'إعداد النشاط التجاري غير مكتمل. fbAccessToken أو businessAccountId مفقود.',
  'Business updated successfully': 'تم تحديث النشاط التجاري بنجاح',
  'Call accepted successfully!': 'تم قبول المكالمة بنجاح!',
  'Call initiated successfully!': 'تم بدء المكالمة بنجاح!',
  'Call messages retrieved successfully': 'تم استرداد رسائل المكالمة بنجاح',
  'Call pre-accepted successfully!': 'تم القبول المسبق للمكالمة بنجاح!',
  'Call rejected successfully!': 'تم رفض المكالمة بنجاح!',
  'Call terminated successfully': 'تم إنهاء المكالمة بنجاح',
  'Call terminated successfully!': 'تم إنهاء المكالمة بنجاح!',
  'Campaign not found': 'لم يتم العثور على الحملة',
  'Cannot Verify Webhook Token!': 'تعذّر التحقق من رمز webhook!',
  'Cannot delete $LATEST version': 'لا يمكن حذف الإصدار $LATEST',
  'Cannot delete a business with completed setup. Only incomplete setups can be deleted.':
    'لا يمكن حذف نشاط تجاري مكتمل الإعداد. يمكن حذف الإعدادات غير المكتملة فقط.',
  'Cannot delete the last business. At least one business is required.':
    'لا يمكن حذف النشاط التجاري الأخير. يلزم وجود نشاط تجاري واحد على الأقل.',
  'Cannot revoke — at least one OWNER must retain access to each business.':
    'لا يمكن الإلغاء — يجب أن يحتفظ واحد على الأقل بدور OWNER بحق الوصول إلى كل نشاط تجاري.',
  'Cannot use "after" and "before" cursors simultaneously.':
    'لا يمكن استخدام مؤشري "after" و"before" في الوقت نفسه.',
  'Chat completion successful': 'تم إكمال المحادثة بنجاح',
  'Chatbot assigned to client successfully':
    'تم إسناد روبوت المحادثة إلى العميل بنجاح',
  'Chatbot assignment removed from client':
    'تمت إزالة إسناد روبوت المحادثة من العميل',
  'Chatbot config retrieved': 'تم استرداد إعدادات روبوت المحادثة',
  'Chatbot conversation triggered successfully':
    'تم تشغيل محادثة روبوت المحادثة بنجاح',
  'Chatbot created successfully': 'تم إنشاء روبوت المحادثة بنجاح',
  'Chatbot deleted successfully': 'تم حذف روبوت المحادثة بنجاح',
  'Chatbot exported successfully': 'تم تصدير روبوت المحادثة بنجاح',
  'Chatbot imported successfully': 'تم استيراد روبوت المحادثة بنجاح',
  'Chatbot not found': 'لم يتم العثور على روبوت المحادثة',
  'Chatbot nudges fetched successfully': 'تم جلب تنبيهات روبوت المحادثة بنجاح',
  'Chatbot response generated successfully': 'تم إنشاء رد روبوت المحادثة بنجاح',
  'Chatbot retrieved successfully': 'تم استرداد روبوت المحادثة بنجاح',
  'Chatbot updated successfully': 'تم تحديث روبوت المحادثة بنجاح',
  'Chatbots retrieved successfully': 'تم استرداد روبوتات المحادثة بنجاح',
  'ClickHouse analytics is not enabled': 'تحليلات ClickHouse غير مفعَّلة',
  'ClickHouse is not available': 'ClickHouse غير متوفر',
  'ClickHouse is unavailable; cannot generate bills.':
    'ClickHouse غير متوفر؛ لا يمكن إنشاء الفواتير.',
  'Client chat status updated successfully':
    'تم تحديث حالة محادثة العميل بنجاح',
  'Client has not opted in': 'لم يوافق العميل على الاشتراك',
  'Client is blocked': 'العميل محظور',
  'Client not found': 'لم يتم العثور على العميل',
  'Clients created/updated successfully': 'تم إنشاء/تحديث العملاء بنجاح',
  'Code executed': 'تم تنفيذ التعليمات البرمجية',
  'Code executed successfully': 'تم تنفيذ التعليمات البرمجية بنجاح',
  'Code saved successfully': 'تم حفظ التعليمات البرمجية بنجاح',
  'Coexistence is not enabled for this business!':
    'ميزة التعايش غير مفعَّلة لهذا النشاط التجاري!',
  'Compressed payload too large': 'حمولة البيانات المضغوطة كبيرة جدًا',
  'Contact not found': 'لم يتم العثور على جهة الاتصال',
  'Contact updated successfully.': 'تم تحديث جهة الاتصال بنجاح.',
  'Copilot response received': 'تم استلام رد Copilot',
  'Cost analytics retrieved successfully': 'تم استرداد تحليلات التكلفة بنجاح',
  'Could not find whatsapp_business_messaging scope with target_ids in granular_scopes':
    'تعذّر العثور على نطاق whatsapp_business_messaging مع target_ids في granular_scopes',
  'Could not prepare storage for upload. Please try again.':
    'تعذّر تجهيز مساحة التخزين للرفع. يرجى المحاولة مرة أخرى.',
  'Could not resolve a contact from the given identifiers':
    'تعذّر تحديد جهة اتصال من المعرّفات المقدَّمة',
  'Credit line attached successfully': 'تم ربط خط الائتمان بنجاح',
  'Currency conversion failed.': 'فشل تحويل العملة.',
  'Daily engagement analytics retrieved successfully':
    'تم استرداد تحليلات التفاعل اليومي بنجاح',
  'Debug context retrieved': 'تم استرداد سياق تصحيح الأخطاء',
  'Edit lock status': 'حالة قفل التحرير',
  'Either phoneNumberId or businessId, clientWaNumber, and either text or messages are required':
    'يلزم توفير phoneNumberId أو businessId، بالإضافة إلى clientWaNumber، وإما text أو messages',
  'Either text, media, or a button/list reply must be provided':
    'يجب توفير نص أو وسائط أو رد عبر زر/قائمة',
  'Email is required': 'البريد الإلكتروني مطلوب',
  'Email is required!': 'البريد الإلكتروني مطلوب!',
  'Email verified. Your account is ready — please log in.':
    'تم التحقق من البريد الإلكتروني. حسابك جاهز — يرجى تسجيل الدخول.',
  'Embed session created.': 'تم إنشاء جلسة التضمين.',
  'Employee not found': 'لم يتم العثور على الموظف',
  'Employee not found!': 'لم يتم العثور على الموظف!',
  'Employee record not found': 'لم يتم العثور على سجل الموظف',
  'Error 500': 'خطأ 500',
  'Error during message search': 'حدث خطأ أثناء البحث في الرسائل',
  'Error fetching business profile details!':
    'حدث خطأ أثناء جلب تفاصيل الملف التجاري!',
  'Error in JWT Token!': 'خطأ في رمز JWT!',
  'Error in SSO authorization.': 'خطأ في تفويض SSO.',
  'Error in authorization.': 'خطأ في التفويض.',
  'Error in embedded signup': 'خطأ في التسجيل المضمّن',
  'Error in fetching single flow': 'حدث خطأ أثناء جلب التدفق',
  'Error updating business profile details!':
    'حدث خطأ أثناء تحديث تفاصيل الملف التجاري!',
  'Error while marking message as read': 'حدث خطأ أثناء تعليم الرسالة كمقروءة',
  'Estimate details fetched successfully.': 'تم جلب تفاصيل التقدير بنجاح.',
  'Estimate marked as accepted.': 'تم تعليم التقدير كمقبول.',
  'Estimate not found.': 'لم يتم العثور على التقدير.',
  'Execution role is not configured. Please contact support.':
    'لم يتم إعداد دور التنفيذ. يرجى التواصل مع الدعم.',
  Forbidden: 'محظور',
  'Facebook Access Token not found': 'لم يتم العثور على رمز وصول Facebook',
  'Failed to accept call': 'فشل قبول المكالمة',
  'Failed to attach credit line for this business':
    'فشل ربط خط الائتمان لهذا النشاط التجاري',
  'Failed to create Karix account for credit line':
    'فشل إنشاء حساب Karix لخط الائتمان',
  'Failed to create flow': 'فشل إنشاء التدفق',
  'Failed to create template': 'فشل إنشاء القالب',
  'Failed to create template with library. Please contact customer support':
    'فشل إنشاء القالب باستخدام المكتبة. يرجى التواصل مع دعم العملاء',
  'Failed to create template. Please contact customer support':
    'فشل إنشاء القالب. يرجى التواصل مع دعم العملاء',
  'Failed to create versioned function.': 'فشل إنشاء دالة ذات إصدارات.',
  'Failed to delete hash templates': 'فشل حذف قوالب hash',
  'Failed to delete template': 'فشل حذف القالب',
  'Failed to delete the flow': 'فشل حذف التدفق',
  'Failed to delete version': 'فشل حذف الإصدار',
  'Failed to deprecate the flow': 'فشل إيقاف العمل بالتدفق',
  'Failed to fetch JsonFlow': 'فشل جلب JsonFlow',
  'Failed to fetch analytics': 'فشل جلب التحليلات',
  'Failed to fetch call settings': 'فشل جلب إعدادات المكالمات',
  'Failed to fetch conversation analytics': 'فشل جلب تحليلات المحادثات',
  'Failed to fetch data localization region from Meta.':
    'فشل جلب منطقة توطين البيانات من Meta.',
  'Failed to fetch data localization region.': 'فشل جلب منطقة توطين البيانات.',
  'Failed to fetch form responses due to a server error':
    'فشل جلب ردود النموذج بسبب خطأ في الخادم',
  'Failed to fetch meta acount health status!': 'فشل جلب حالة سلامة حساب Meta!',
  'Failed to fetch pricing analytics': 'فشل جلب تحليلات التسعير',
  'Failed to fetch template analytics': 'فشل جلب تحليلات القوالب',
  'Failed to fetch whatsapp commerce settings':
    'فشل جلب إعدادات التجارة في WhatsApp',
  'Failed to generate Karix token for credit line':
    'فشل إنشاء رمز Karix لخط الائتمان',
  'Failed to generate system prompt. Please try again.':
    'فشل إنشاء موجّه النظام. يرجى المحاولة مرة أخرى.',
  'Failed to get response from AI. Please try again.':
    'فشل الحصول على رد من الذكاء الاصطناعي. يرجى المحاولة مرة أخرى.',
  'Failed to initiate call': 'فشل بدء المكالمة',
  'Failed to pre-accept call': 'فشل القبول المسبق للمكالمة',
  'Failed to preview the flow': 'فشلت معاينة التدفق',
  'Failed to process templates': 'فشلت معالجة القوالب',
  'Failed to publish the flow': 'فشل نشر التدفق',
  'Failed to register phone number!': 'فشل تسجيل رقم الهاتف!',
  'Failed to reject call': 'فشل رفض المكالمة',
  'Failed to request coexistence sync!': 'فشل طلب مزامنة التعايش!',
  'Failed to retrieve template message analytics':
    'فشل استرداد تحليلات رسائل القالب',
  'Failed to send typing indicator!': 'فشل إرسال مؤشر الكتابة!',
  'Failed to subscribe to webhooks!': 'فشل الاشتراك في webhooks!',
  'Failed to terminate call': 'فشل إنهاء المكالمة',
  'Failed to update call settings': 'فشل تحديث إعدادات المكالمات',
  'Failed to update data localization region on Meta.':
    'فشل تحديث منطقة توطين البيانات على Meta.',
  'Failed to update data localization region.':
    'فشل تحديث منطقة توطين البيانات.',
  'Failed to update jwt token': 'فشل تحديث رمز jwt',
  'Failed to update template': 'فشل تحديث القالب',
  'Failed to update the flow': 'فشل تحديث التدفق',
  'Failed to update whatsapp commerce settings':
    'فشل تحديث إعدادات التجارة في whatsapp',
  'Failed to upload through Resumable API': 'فشل الرفع عبر Resumable API',
  'Fallback config deleted successfully': 'تم حذف تكوين الاحتياط بنجاح',
  'Fallback config not found': 'لم يتم العثور على تكوين الاحتياط',
  'Fallback config saved successfully': 'تم حفظ تكوين الاحتياط بنجاح',
  'Fallback configs fetched successfully': 'تم جلب تكوينات الاحتياط بنجاح',
  'Fetch flows error': 'خطأ في جلب التدفقات',
  'Fetched data localization region.': 'تم جلب منطقة توطين البيانات.',
  'Fetched function details': 'تم جلب تفاصيل الدالة',
  'Fetched versions': 'تم جلب الإصدارات',
  'Field name too long.': 'اسم الحقل طويل جدًا.',
  'Field value too long.': 'قيمة الحقل طويلة جدًا.',
  'File is required': 'الملف مطلوب',
  'File not accessible': 'تعذر الوصول إلى الملف',
  'File not found in request body!': 'لم يتم العثور على الملف في نص الطلب!',
  'File too large. Please upload a smaller file.':
    'الملف كبير جدًا. يُرجى رفع ملف أصغر.',
  'File type and file name are required!': 'نوع الملف واسم الملف مطلوبان!',
  'Filename is too long. Maximum 255 characters allowed.':
    'اسم الملف طويل جدًا. الحد الأقصى المسموح به هو 255 حرفًا.',
  'Flow executed': 'تم تنفيذ التدفق',
  'Function bundle not available': 'حزمة الدالة غير متوفرة',
  'Function executed successfully': 'تم تنفيذ الدالة بنجاح',
  'GST status fetched successfully.': 'تم جلب حالة GST بنجاح.',
  'GSTIN updated successfully.': 'تم تحديث GSTIN بنجاح.',
  'Graph API Error': 'خطأ في Graph API',
  'Group deletion requested': 'تم طلب حذف المجموعة',
  'Group info retrieved': 'تم استرداد معلومات المجموعة',
  'Group settings update requested': 'تم طلب تحديث إعدادات المجموعة',
  'HTTP request executed': 'تم تنفيذ طلب HTTP',
  Hello: 'مرحبًا',
  'Hello there': 'مرحبًا بك',
  'Hello!': 'مرحبًا!',
  Hi: 'أهلًا',
  'Hi there': 'أهلًا بك',
  'Incorrect or expired code. If it keeps failing, please start the sign-up again to get a new code.':
    'الرمز غير صحيح أو منتهي الصلاحية. إذا استمر الفشل، يُرجى بدء إنشاء الحساب من جديد للحصول على رمز جديد.',
  'Invalid 2FA token': 'رمز 2FA غير صالح',
  'Invalid 2FA token. Please provide a valid token to disable 2FA.':
    'رمز 2FA غير صالح. يُرجى تقديم رمز صالح لتعطيل 2FA.',
  'Invalid 2FA token. Please try again.':
    'رمز 2FA غير صالح. يُرجى المحاولة مرة أخرى.',
  'Invalid Google token': 'رمز Google غير صالح',
  'Invalid HTTP request options': 'خيارات طلب HTTP غير صالحة',
  'Invalid Pipecat secret': 'المفتاح السري لـ Pipecat غير صالح',
  'Invalid Web Verification Token': 'رمز التحقق عبر الويب غير صالح',
  'Invalid amount. Must be greater than 0.':
    'المبلغ غير صالح. يجب أن يكون أكبر من 0.',
  'Invalid business ID': 'معرّف النشاط التجاري غير صالح',
  'Invalid business context': 'سياق النشاط التجاري غير صالح',
  'Invalid business id.': 'معرّف النشاط التجاري غير صالح.',
  'Invalid config ID': 'معرّف التكوين غير صالح',
  'Invalid cursor format': 'تنسيق المؤشر (cursor) غير صالح',
  'Invalid date format. Expected YYYY-MM-DD format (e.g., "2025-11-01").':
    'تنسيق التاريخ غير صالح. التنسيق المتوقع هو YYYY-MM-DD (مثال: "2025-11-01").',
  'Invalid date format. Use YYYY-MM-DD':
    'تنسيق التاريخ غير صالح. استخدم YYYY-MM-DD',
  'Invalid destination phone number': 'رقم هاتف الوجهة غير صالح',
  'Invalid email or password': 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  'Invalid email or password2.': 'البريد الإلكتروني أو كلمة المرور2 غير صحيحة.',
  'Invalid employee ID': 'معرّف الموظف غير صالح',
  'Invalid filename. Please use a safe filename without special characters.':
    'اسم الملف غير صالح. يُرجى استخدام اسم ملف آمن بدون أحرف خاصة.',
  'Invalid message type': 'نوع الرسالة غير صالح',
  'Invalid or missing orgId parameter.': 'المعامل orgId غير صالح أو مفقود.',
  'Invalid org ID': 'معرّف المؤسسة غير صالح',
  'Invalid request data': 'بيانات الطلب غير صالحة',
  'Invalid response data': 'بيانات الاستجابة غير صالحة',
  'Invalid voice bot secret': 'المفتاح السري لروبوت الصوت غير صالح',
  'Invalid webhook signature': 'توقيع webhook غير صالح',
  'Invite link reset': 'تمت إعادة تعيين رابط الدعوة',
  'Invite link retrieved': 'تم استرداد رابط الدعوة',
  'Invite valid': 'الدعوة صالحة',
  'Invoice URL fetched successfully.': 'تم جلب عنوان URL للفاتورة بنجاح.',
  'Invoice is not available for this bill yet.':
    'الفاتورة غير متوفرة لسجل الفوترة هذا بعد.',
  'Iteration complete': 'اكتمل التكرار',
  'Join requests approved': 'تمت الموافقة على طلبات الانضمام',
  'Join requests rejected': 'تم رفض طلبات الانضمام',
  'Join requests retrieved': 'تم استرداد طلبات الانضمام',
  'Journey not found': 'لم يتم العثور على Journey',
  'Just one': 'واحد فقط',
  'KARIX_ACCESS_TOKEN is not configured': 'لم يتم تكوين KARIX_ACCESS_TOKEN',
  'Legacy API key(s) revoked successfully': 'تم إبطال مفاتيح API القديمة بنجاح',
  'Link successfully created.': 'تم إنشاء الرابط بنجاح.',
  'Links successfully created.': 'تم إنشاء الروابط بنجاح.',
  'Links successfully retrieved.': 'تم استرداد الروابط بنجاح.',
  'Live chatbots config updated successfully':
    'تم تحديث تكوين روبوتات المحادثة المباشرة بنجاح',
  'LiveKit agent name is not configured': 'لم يتم تكوين اسم وكيل LiveKit',
  'LiveKit credentials are not configured':
    'لم يتم تكوين بيانات اعتماد LiveKit',
  'Logged out successfully': 'تم تسجيل الخروج بنجاح',
  'Message ID is required!': 'معرّف الرسالة مطلوب!',
  'Message marked as read!': 'تم تحديد الرسالة كمقروءة!',
  'Message not found': 'لم يتم العثور على الرسالة',
  'Message search is currently unavailable. Please try again later.':
    'البحث في الرسائل غير متاح حاليًا. يُرجى المحاولة مرة أخرى لاحقًا.',
  'Message search timed out. Please refine your query and try again.':
    'انتهت مهلة البحث في الرسائل. يُرجى تحسين استعلامك والمحاولة مرة أخرى.',
  'Messages sent successfully': 'تم إرسال الرسائل بنجاح',
  'Meta agent not found': 'لم يتم العثور على وكيل Meta',
  'Meta AI is handling this chat. Only Meta can hand a conversation to a human — it does that on its own when it decides one is needed. To stop the agent everywhere, unpublish it.':
    'يتولى Meta AI إدارة هذه المحادثة. Meta وحدها هي من يمكنها تحويل المحادثة إلى إنسان — وهي تفعل ذلك تلقائيًا عندما ترى ضرورة لذلك. لإيقاف الوكيل في كل مكان، قم بإلغاء نشره.',
  'Missing X-Pipecat-Secret header': 'الترويسة X-Pipecat-Secret مفقودة',
  'Missing X-Voice-Bot-Secret header': 'الترويسة X-Voice-Bot-Secret مفقودة',
  'Missing authorization header': 'ترويسة التفويض مفقودة',
  'Missing edit session id': 'معرّف جلسة التحرير مفقود',
  'Models retrieved successfully': 'تم استرداد النماذج بنجاح',
  'Monitoring data fetched successfully': 'تم جلب بيانات المراقبة بنجاح',
  'No Meta AI agent is configured on this number yet':
    'لم يتم تكوين وكيل Meta AI على هذا الرقم بعد',
  'No Meta agent is active': 'لا يوجد وكيل Meta نشط',
  'No SIP configuration found': 'لم يتم العثور على تكوين SIP',
  'No active LLM API key found. Please configure an API key first.':
    'لم يتم العثور على مفتاح LLM API نشط. يُرجى تكوين مفتاح API أولًا.',
  'No active call found': 'لم يتم العثور على مكالمة نشطة',
  'No active employee found to assign chat!':
    'لم يتم العثور على موظف نشط لإسناد المحادثة إليه!',
  'No billing configured for this organization.':
    'لم يتم تكوين الفوترة لهذه المؤسسة.',
  'No billing data for this period.': 'لا توجد بيانات فوترة لهذه الفترة.',
  'No business context — pass businessId or use a business-scoped JWT.':
    'لا يوجد سياق نشاط تجاري — مرّر businessId أو استخدم رمز JWT مقيّدًا بنشاط تجاري.',
  'No businesses found for this org':
    'لم يتم العثور على أنشطة تجارية لهذه المؤسسة',
  'No organizations found for this partner':
    'لم يتم العثور على مؤسسات لهذا الشريك',
  'No call found for this callId':
    'لم يتم العثور على مكالمة لهذا المعرّف (callId)',
  'No call message found to update (early failure)':
    'لم يتم العثور على رسالة مكالمة لتحديثها (فشل مبكر)',
  'No chatbot available for this business':
    'لا يوجد روبوت محادثة متاح لهذا النشاط التجاري',
  'No chatbotId provided and no active voice bot configured':
    'لم يتم تقديم chatbotId ولم يتم تكوين روبوت صوت نشط',
  'No hash templates found to delete': 'لم يتم العثور على قوالب hash لحذفها',
  'No org found': 'لم يتم العثور على مؤسسة',
  'No organization is associated with this account.':
    'لا توجد مؤسسة مرتبطة بهذا الحساب.',
  'No responseData found in responseMiddleware':
    'لم يتم العثور على responseData في responseMiddleware',
  'No retainer invoice found for this estimate. Make sure the estimate has been accepted in Zoho first.':
    'لم يتم العثور على فاتورة دفعة مقدمة لعرض الأسعار هذا. تأكد أولًا من قبول عرض الأسعار في Zoho.',
  'No templates found to process': 'لم يتم العثور على قوالب لمعالجتها',
  'No valid message content': 'لا يوجد محتوى رسالة صالح',
  'No voice bot configured': 'لم يتم تكوين روبوت صوت',
  'Not Enabled.': 'غير مفعّل.',
  'Not found.': 'غير موجود.',
  'Nudge scheduled successfully': 'تمت جدولة التذكير بنجاح',
  'OAuth client successfully created.': 'تم إنشاء عميل OAuth بنجاح.',
  'One or more chatbots do not belong to this organization':
    'روبوت محادثة واحد أو أكثر لا ينتمي إلى هذه المؤسسة',
  'Only an OWNER can manage business access.':
    'يمكن للمالك (OWNER) فقط إدارة الوصول إلى النشاط التجاري.',
  'Only an OWNER can restore a deleted employee.':
    'يمكن للمالك (OWNER) فقط استعادة موظف محذوف.',
  'Org ID or business id not found in JWT payload!':
    'لم يتم العثور على معرّف المؤسسة أو معرّف النشاط التجاري في حمولة JWT!',
  'Org context missing in request': 'سياق المؤسسة مفقود في الطلب',
  'Org not found': 'لم يتم العثور على المؤسسة',
  'Org pricing updated successfully.': 'تم تحديث تسعير المؤسسة بنجاح.',
  'Org-level functions retrieved successfully':
    'تم استرداد الدوال على مستوى المؤسسة بنجاح',
  'Org-wide scope requires access to every business in the org.':
    'يتطلب النطاق على مستوى المؤسسة الوصول إلى كل نشاط تجاري في المؤسسة.',
  'Org-wide scope is not available for this session.':
    'النطاق على مستوى المؤسسة غير متاح لهذه الجلسة.',
  'Template-wise cost analytics is only available per business':
    'تحليلات التكلفة حسب القالب متاحة فقط لكل نشاط تجاري',
  'Org-wide account status is not available for this session.':
    'حالة الحساب على مستوى المؤسسة غير متاحة لهذه الجلسة.',
  'Organization not found or does not belong to this partner.':
    'لم يتم العثور على المؤسسة أو أنها لا تنتمي إلى هذا الشريك.',
  'Organization not found.': 'لم يتم العثور على المؤسسة.',
  'Outbound call initiated': 'تم بدء المكالمة الصادرة',
  'PIPECAT_SECRET not configured': 'لم يتم تكوين PIPECAT_SECRET',
  'Participant removal requested': 'تم طلب إزالة المشارك',
  'Partner admin added successfully.': 'تمت إضافة مشرف الشريك بنجاح.',
  'Partner admin not found.': 'لم يتم العثور على مشرف الشريك.',
  'Partner admin removed successfully.': 'تمت إزالة مشرف الشريك بنجاح.',
  'Partner admins fetched successfully.': 'تم جلب مشرفي الشريك بنجاح.',
  'Partner businesses fetched successfully.':
    'تم جلب الأنشطة التجارية للشريك بنجاح.',
  'Partner context fetched successfully.': 'تم جلب سياق الشريك بنجاح.',
  'Partner context not found.': 'لم يتم العثور على سياق الشريك.',
  'Partner created successfully.': 'تم إنشاء الشريك بنجاح.',
  'Partner not found.': 'لم يتم العثور على الشريك.',
  'Partner orgs fetched successfully.': 'تم جلب مؤسسات الشريك بنجاح.',
  'Partner updated successfully.': 'تم تحديث الشريك بنجاح.',
  'Partners fetched successfully.': 'تم جلب الشركاء بنجاح.',
  'Password updated successfully!': 'تم تحديث كلمة المرور بنجاح!',
  'Patch result reported': 'تم الإبلاغ عن نتيجة التصحيح',
  'Path Does Not Exist': 'المسار غير موجود',
  'Payload must be a non-empty array of client updates':
    'يجب أن تكون الحمولة مصفوفة غير فارغة من تحديثات العملاء',
  'Phone Number ID or FB Access Token is missing!':
    'Phone Number ID أو FB Access Token مفقود!',
  'Phone number ID or access token is missing on the business profile.':
    'معرّف رقم الهاتف أو رمز الوصول مفقود في ملف النشاط التجاري.',
  'Phone number ID or access token not found':
    'لم يتم العثور على معرّف رقم الهاتف أو رمز الوصول',
  'Phone number id or fb access token is missing!':
    'معرّف رقم الهاتف أو رمز وصول fb مفقود!',
  'Pick any\\n\\n1. Pizza\\n2. Pasta':
    'اختر أيًا منها\\n\\n1. بيتزا\\n2. باستا',
  'Please setup account first': 'يُرجى إعداد الحساب أولًا',
  'Policy Bazar lead dispatched to LiveKit':
    'تم إرسال العميل المحتمل من Policy Bazar إلى LiveKit',
  'Presigned URL generated': 'تم إنشاء عنوان URL موقّع مسبقًا',
  'Presigned download URL generated': 'تم إنشاء عنوان URL موقّع مسبقًا للتنزيل',
  'Presigned upload URL generated': 'تم إنشاء عنوان URL موقّع مسبقًا للرفع',
  'Query executed': 'تم تنفيذ الاستعلام',
  'Query exported to S3': 'تم تصدير الاستعلام إلى S3',
  'Quick Replies added successfully': 'تمت إضافة الردود السريعة بنجاح',
  'Re-engagement message': 'رسالة إعادة التفاعل',
  'Real one': 'واحد حقيقي',
  'Redirect link not found.': 'لم يتم العثور على رابط إعادة التوجيه.',
  'Request Failed with Internal Server Error': 'فشل الطلب بخطأ داخلي في الخادم',
  'Retainer invoice activated.': 'تم تفعيل فاتورة الدفعة المقدمة.',
  'rollout.enabled is required — agent settings have not been initialized yet':
    'rollout.enabled مطلوب — لم تتم تهيئة إعدادات الوكيل بعد',
  'SIP call accepted': 'تم قبول مكالمة SIP',
  'SIP call initiated': 'تم بدء مكالمة SIP',
  'SIP call rejected': 'تم رفض مكالمة SIP',
  'SIP call terminated': 'تم إنهاء مكالمة SIP',
  'SIP call terminated successfully': 'تم إنهاء مكالمة SIP بنجاح',
  'SIP configuration removed': 'تمت إزالة تكوين SIP',
  'SIP configured successfully': 'تم تكوين SIP بنجاح',
  'SIP is not configured. Run setup first.':
    'لم يتم تكوين SIP. قم بتشغيل الإعداد أولًا.',
  'SIP trunk not found on LiveKit. Re-run SIP setup (Settings → SIP Calling) to reconnect the trunk.':
    'لم يتم العثور على خط SIP trunk على LiveKit. أعد تشغيل إعداد SIP (الإعدادات ← مكالمات SIP) لإعادة توصيل الخط.',
  'SMS channel is not yet available': 'قناة SMS غير متاحة بعد',
  'Search query only contains unsupported characters':
    'استعلام البحث يحتوي فقط على أحرف غير مدعومة',
  'Send queue temporarily unavailable, retry after a few seconds':
    'قائمة انتظار الإرسال غير متاحة مؤقتًا، أعد المحاولة بعد بضع ثوانٍ',
  'Session cleared successfully': 'تم مسح الجلسة بنجاح',
  'Session has been logged out': 'تم تسجيل خروج الجلسة',
  'Session info fetched': 'تم جلب معلومات الجلسة',
  'Session logged out successfully': 'تم تسجيل خروج الجلسة بنجاح',
  'Session not found': 'لم يتم العثور على الجلسة',
  'Sessions retrieved successfully': 'تم استرداد الجلسات بنجاح',
  'Settings updated': 'تم تحديث الإعدادات',
  'Setup your Facebook account first!':
    'قم بإعداد حساب Facebook الخاص بك أولاً!',
  'Short URL collision occured. Try again or increase length and try again.':
    'حدث تعارض في عنوان URL المختصر. حاول مرة أخرى أو قم بزيادة الطول ثم حاول مجددًا.',
  'Short URL collision occurred. Please try again with a longer hash length.':
    'حدث تعارض في عنوان URL المختصر. يرجى المحاولة مرة أخرى باستخدام طول hash أكبر.',
  'Some employees do not exist!': 'بعض الموظفين غير موجودين!',
  'Source and fallback template cannot be the same':
    'لا يمكن أن يكون القالب المصدر والقالب الاحتياطي متطابقين',
  'Stored attribute configuration could not be read':
    'تعذر قراءة إعدادات السمات المخزنة',
  'Successfully Fetched Attributes': 'تم جلب السمات بنجاح',
  'Successfully added or updated webhook URL':
    'تمت إضافة عنوان URL الخاص بـ webhook أو تحديثه بنجاح',
  'Successfully added webhook': 'تمت إضافة webhook بنجاح',
  'Successfully created business api-key!':
    'تم إنشاء api-key للنشاط التجاري بنجاح!',
  'Successfully deleted clients': 'تم حذف العملاء بنجاح',
  'Successfully deleted scheduled!': 'تم حذف العنصر المجدول بنجاح!',
  'Successfully deleted session!': 'تم حذف الجلسة بنجاح!',
  'Successfully deleted webhook': 'تم حذف webhook بنجاح',
  'Successfully deleted webhook URL': 'تم حذف عنوان URL الخاص بـ webhook بنجاح',
  'Successfully fetched all businesses.': 'تم جلب جميع الأنشطة التجارية بنجاح.',
  'Successfully fetched all employees.': 'تم جلب جميع الموظفين بنجاح.',
  'Successfully fetched all orgs.': 'تم جلب جميع المؤسسات بنجاح.',
  'Successfully fetched analytics!': 'تم جلب التحليلات بنجاح!',
  'Successfully fetched call settings!': 'تم جلب إعدادات المكالمات بنجاح!',
  'Successfully fetched form responses': 'تم جلب ردود النموذج بنجاح',
  'Successfully fetched pricing analytics!': 'تم جلب تحليلات التسعير بنجاح!',
  'Successfully generated CSV file for Cars24 delivery report':
    'تم إنشاء ملف CSV لتقرير التسليم الخاص بـ Cars24 بنجاح',
  'Successfully logged in!': 'تم تسجيل الدخول بنجاح!',
  'Successfully previewed the flow!': 'تمت معاينة التدفق بنجاح!',
  'Successfully queued messages': 'تمت إضافة الرسائل إلى قائمة الانتظار بنجاح',
  'Successfully retrieved campaign Stats.': 'تم استرداد إحصائيات الحملة بنجاح.',
  'Successfully retrieved campaign list': 'تم استرداد قائمة الحملات بنجاح',
  'Successfully retrieved client attributes': 'تم استرداد سمات العميل بنجاح',
  'Successfully retrieved client details': 'تم استرداد تفاصيل العميل بنجاح',
  'Successfully retrieved client list': 'تم استرداد قائمة العملاء بنجاح',
  'Successfully retrieved group list': 'تم استرداد قائمة المجموعات بنجاح',
  'Successfully retrieved message': 'تم استرداد الرسالة بنجاح',
  'Successfully retrieved messages': 'تم استرداد الرسائل بنجاح',
  'Successfully scheduled messages!': 'تمت جدولة الرسائل بنجاح!',
  'Successfully send read status!': 'تم إرسال حالة القراءة بنجاح!',
  'Successfully start heltarbot flow!': 'تم بدء تدفق heltarbot بنجاح!',
  'Successfully update jwt token': 'تم تحديث رمز jwt بنجاح',
  'Successfully updated call settings!': 'تم تحديث إعدادات المكالمات بنجاح!',
  'Successfully updated employee.': 'تم تحديث الموظف بنجاح.',
  'Successfully updated org.': 'تم تحديث المؤسسة بنجاح.',
  'Successfully updated the flow!': 'تم تحديث التدفق بنجاح!',
  'Support email config fetched successfully.':
    'تم جلب إعدادات البريد الإلكتروني للدعم بنجاح.',
  'Support email config updated successfully.':
    'تم تحديث إعدادات البريد الإلكتروني للدعم بنجاح.',
  'Sure!': 'بالتأكيد!',
  'System prompt generated successfully': 'تم إنشاء موجه النظام بنجاح',
  'Target business is in a different organisation.':
    'النشاط التجاري المستهدف ينتمي إلى مؤسسة مختلفة.',
  'Target business not found.': 'لم يتم العثور على النشاط التجاري المستهدف.',
  'Template analytics retrieved successfully from ClickHouse':
    'تم استرداد تحليلات القوالب من ClickHouse بنجاح',
  'Template category updates fetched successfully':
    'تم جلب تحديثات فئات القوالب بنجاح',
  'Template cost analytics retrieved successfully':
    'تم استرداد تحليلات تكلفة القوالب بنجاح',
  'Template details retrieved successfully from ClickHouse':
    'تم استرداد تفاصيل القالب من ClickHouse بنجاح',
  'Template message analytics retrieved successfully':
    'تم استرداد تحليلات رسائل القوالب بنجاح',
  'Testing custom error': 'اختبار خطأ مخصص',
  "The 'OWNER' role must have 'permissionManagement' enabled.":
    "يجب أن يكون خيار 'permissionManagement' مفعّلاً لدور 'OWNER'.",
  'The GSTIN has an unrecognized state code.':
    'يحتوي رقم GSTIN على رمز ولاية غير معروف.',
  'This API is not accessible with an API key.':
    'لا يمكن الوصول إلى واجهة API هذه باستخدام مفتاح API.',
  'This account is billed from Meta but has no WhatsApp Business Account connected, so template-wise costs cannot be retrieved':
    'يتم إصدار فواتير هذا الحساب من Meta ولكن لا يوجد حساب WhatsApp Business مرتبط به، لذا يتعذّر استرداد التكاليف حسب القالب',
  'Usage data could not be retrieved from Meta for this account, so cost analytics cannot be shown right now':
    'تعذّر استرداد بيانات الاستخدام من Meta لهذا الحساب، لذا لا يمكن عرض تحليلات التكلفة في الوقت الحالي',
  'Template analytics is turned off for this WhatsApp Business Account, so Meta has no per-template usage to show':
    'تحليلات القوالب متوقفة لحساب WhatsApp Business هذا، لذا لا يوجد لدى Meta استخدام حسب القالب لعرضه',
  'Meta reported no template deliveries for this period although usage was billed, so template-wise costs cannot be shown':
    'لم تُبلغ Meta عن أي عمليات تسليم للقوالب في هذه الفترة رغم أنه تمت فوترة الاستخدام، لذا يتعذّر عرض التكاليف حسب القالب',
  'This account has been deleted. Please contact your administrator.':
    'تم حذف هذا الحساب. يرجى التواصل مع المسؤول لديك.',
  'This action requires a logged-in session, not an API key.':
    'يتطلب هذا الإجراء جلسة تسجيل دخول، وليس مفتاح API.',
  'This email address is already linked to another contact':
    'عنوان البريد الإلكتروني هذا مرتبط بالفعل بجهة اتصال أخرى',
  'This embed link has expired or was already used. Reopen it from your CRM.':
    'انتهت صلاحية رابط التضمين هذا أو تم استخدامه بالفعل. أعد فتحه من نظام CRM الخاص بك.',
  'Password is required to activate your account.':
    'كلمة المرور مطلوبة لتفعيل حسابك.',
  'This invite is invalid or has expired.':
    'هذه الدعوة غير صالحة أو منتهية الصلاحية.',
  'Timed out while waiting for function update to finish':
    'انتهت المهلة أثناء انتظار اكتمال تحديث الدالة',
  'Token and new password are required!': 'الرمز وكلمة المرور الجديدة مطلوبان!',
  'Token invalid or expired!': 'الرمز غير صالح أو منتهي الصلاحية!',
  'Token not provided': 'لم يتم تقديم الرمز',
  'Token successfully created.': 'تم إنشاء الرمز بنجاح.',
  'Too many fields.': 'عدد الحقول كبير جدًا.',
  'Too many files. Please upload fewer files.':
    'عدد الملفات كبير جدًا. يرجى رفع عدد أقل من الملفات.',
  'Too many parts in multipart data.':
    'عدد الأجزاء في بيانات multipart كبير جدًا.',
  'Transaction history retrieved successfully':
    'تم استرداد سجل المعاملات بنجاح',
  'Transcript saved to call message': 'تم حفظ النص المكتوب في رسالة المكالمة',
  'Unable to dispatch Policy Bazar lead to LiveKit':
    'تعذر إرسال العميل المحتمل من Policy Bazar إلى LiveKit',
  'Unexpected file field.': 'حقل ملف غير متوقع.',
  'Update Template is not supported. Please make new template.':
    'تحديث القالب غير مدعوم. يرجى إنشاء قالب جديد.',
  'Updated widget allowed origins': 'تم تحديث المصادر المسموح بها للأداة',
  'visitorId must be your own test visitor id':
    'يجب أن يكون visitorId هو معرف زائر الاختبار الخاص بك',
  'Upload failed': 'فشل الرفع',
  Uploaded: 'تم الرفع',
  'User ID and token are required': 'معرّف المستخدم والرمز مطلوبان',
  'User ID is required': 'معرّف المستخدم مطلوب',
  'User not found': 'لم يتم العثور على المستخدم',
  'VOICE_BOT_SECRET not configured': 'لم يتم تكوين VOICE_BOT_SECRET',
  'Valid businessId is required.': 'يلزم توفير businessId صالح.',
  'Valid employee ID is required.': 'يلزم توفير معرّف موظف صالح.',
  'Valid org ID is required.': 'يلزم توفير معرّف مؤسسة صالح.',
  'Valid orgId is required.': 'يلزم توفير orgId صالح.',
  'Valid partner ID is required.': 'يلزم توفير معرّف شريك صالح.',
  'Valid version number is required': 'يلزم توفير رقم إصدار صالح',
  'Voice bot test room ready': 'غرفة اختبار الروبوت الصوتي جاهزة',
  'Voice call fetched': 'تم جلب المكالمة الصوتية',
  'Voice calls listed': 'تم سرد المكالمات الصوتية',
  'Wallet information retrieved successfully':
    'تم استرداد معلومات المحفظة بنجاح',
  'We could not create this account. It may already exist — try logging in.':
    'تعذر علينا إنشاء هذا الحساب. قد يكون موجودًا بالفعل — حاول تسجيل الدخول.',
  'Webhook processed': 'تمت معالجة webhook',
  'Welcome!': 'مرحبًا بك!',
  'What is your name?': 'ما اسمك؟',
  'WhatsApp notification sent successfully': 'تم إرسال إشعار WhatsApp بنجاح',
  'Whatsapp api signUp again to run this operation':
    'أعد التسجيل عبر WhatsApp API لتنفيذ هذه العملية',
  'You are not authorized to access this resource':
    'غير مصرح لك بالوصول إلى هذا المورد',
  'You can only fetch your own employee record.':
    'يمكنك جلب سجل الموظف الخاص بك فقط.',
  'You can only grant access to businesses you can access.':
    'يمكنك منح الوصول فقط إلى الأنشطة التجارية التي يمكنك الوصول إليها.',
  'You cannot create tags. You can directly update the tags options':
    'لا يمكنك إنشاء وسوم. يمكنك تحديث خيارات الوسوم مباشرةً',
  'You do not have access to this business. Contact your account owner.':
    'ليس لديك حق الوصول إلى هذا النشاط التجاري. تواصل مع مالك حسابك.',
  'You do not have partner dashboard access.':
    'ليس لديك حق الوصول إلى لوحة تحكم الشركاء.',
  'You do not have permission to log out other users.':
    'ليس لديك إذن لتسجيل خروج مستخدمين آخرين.',
  'Your account has no business access. Please contact your account owner.':
    'لا يملك حسابك حق الوصول إلى أي نشاط تجاري. يرجى التواصل مع مالك حسابك.',
  'Your account is ready. You can now log in.':
    'حسابك جاهز. يمكنك الآن تسجيل الدخول.',
  'Your admin access is read-only. This action is not permitted.':
    'صلاحية المسؤول لديك للقراءة فقط. هذا الإجراء غير مسموح به.',
  'Zoho customers fetched successfully.': 'تم جلب عملاء Zoho بنجاح.',
  'Zoho estimate fetched successfully.': 'تم جلب تقدير Zoho بنجاح.',
  'Zoho estimate not found.': 'لم يتم العثور على تقدير Zoho.',
  'Zoho estimates fetched successfully.': 'تم جلب تقديرات Zoho بنجاح.',
  'attribute parameter is missing in the request.':
    'المعامل attribute مفقود في الطلب.',
  'businessId is required and must be a number.':
    'businessId مطلوب ويجب أن يكون رقمًا.',
  'businessId, clientWaNumber, and callUuid are required':
    'businessId وclientWaNumber وcallUuid مطلوبة',
  'businessIds must be an array.': 'يجب أن يكون businessIds مصفوفة.',
  'callId and either phoneNumberId or businessId are required':
    'يلزم توفير callId مع phoneNumberId أو businessId',
  'callId is required': 'callId مطلوب',
  'chatbotId and phoneNumberId or businessId are required':
    'يلزم توفير chatbotId مع phoneNumberId أو businessId',
  'chatbotId is required': 'chatbotId مطلوب',
  'clientWaNumber and businessId are required.':
    'clientWaNumber وbusinessId مطلوبان.',
  'clientWaNumber and phoneNumberId are required.':
    'clientWaNumber وphoneNumberId مطلوبان.',
  'clientWaNumber is required': 'clientWaNumber مطلوب',
  'clientWaNumbers parameter is missing in the request.':
    'المعامل clientWaNumbers مفقود في الطلب.',
  'codeZipBase64 payload is empty': 'حمولة codeZipBase64 فارغة',
  'contactId is required': 'contactId مطلوب',
  'employeeId is required': 'employeeId مطلوب',
  'endDate must not be before startDate.':
    'يجب ألا يكون endDate قبل startDate.',
  'expirationDays (1-30) is required when action=pin':
    'expirationDays (1-30) مطلوب عندما يكون action=pin',
  'flowDefinition is required for flow chatbots':
    'flowDefinition مطلوب لروبوتات المحادثة القائمة على التدفق',
  'function not found for this org': 'لم يتم العثور على دالة لهذه المؤسسة',
  'hasAccess must be a boolean.': 'يجب أن يكون hasAccess قيمة منطقية.',
  'invocation failed': 'فشل الاستدعاء',
  'media.url must be a Heltar-hosted upload URL':
    'يجب أن يكون media.url عنوان URL لملف مرفوع مستضاف لدى Heltar',
  'name, chatbotId, and either phoneNumberId or businessId are required':
    'يلزم توفير name وchatbotId مع phoneNumberId أو businessId',
  'oldattribute and newattribute in case of tags should be same.':
    'يجب أن يكون oldattribute وnewattribute متطابقين في حالة tags.',
  'orgId not found in JWT': 'لم يتم العثور على orgId في JWT',
  'recipientCount is required with finalPayloadFileUrl':
    'recipientCount مطلوب مع finalPayloadFileUrl',
  'registrationNo and mobileNumber are required':
    'registrationNo وmobileNumber مطلوبان',
  'registrationNumber and mobile are required':
    'registrationNumber وmobile مطلوبان',
  'roomName is required': 'roomName مطلوب',
  'since must be an epoch timestamp':
    'يجب أن يكون since طابعًا زمنيًا بصيغة epoch',
  'startDate and endDate are required': 'startDate وendDate مطلوبان',
  'startDate and endDate must be valid dates.':
    'يجب أن يكون startDate وendDate تاريخين صالحين.',
  'startDate and endDate query params are required (YYYY-MM-DD)':
    'معاملا الاستعلام startDate وendDate مطلوبان (YYYY-MM-DD)',
  'startDate must be before endDate': 'يجب أن يكون startDate قبل endDate',
  'tags attribute canot be deleted.': 'لا يمكن حذف السمة tags.',
  'templateName and date are required': 'templateName وdate مطلوبان',
  'wamid query parameter is required': 'معامل الاستعلام wamid مطلوب',
  'zohoEstimateId is required': 'zohoEstimateId مطلوب',
  'zohoEstimateId is required.': 'zohoEstimateId مطلوب.',
  'Failed to deploy code. Please try again.':
    'فشل نشر التعليمات البرمجية. حاول مرة أخرى.',
  'Save your code before creating a version.': 'احفظ الكود قبل إنشاء إصدار.',
  'Failed to create the version. Please try again.':
    'فشل إنشاء الإصدار. يرجى المحاولة مرة أخرى.',
  'Failed to download the code bundle. Please try again.':
    'فشل تنزيل حزمة التعليمات البرمجية. حاول مرة أخرى.',
  'The deployment did not complete. Please try again.':
    'لم يكتمل النشر. حاول مرة أخرى.',
  'The function could not be created. Please check your configuration or try again.':
    'تعذّر إنشاء الدالة. تحقق من الإعدادات ثم حاول مرة أخرى.',
  'ROUTE_MOBILE_SYSTEM_USER_TOKEN is not configured':
    'لم يتم تكوين ROUTE_MOBILE_SYSTEM_USER_TOKEN',
  'Credit line attachment is not available for this sign-up type':
    'ربط خط الائتمان غير متاح لنوع التسجيل هذا',
  'Route Mobile system user token was rejected by Meta':
    'رفضت Meta رمز مستخدم النظام الخاص بـ Route Mobile',
  'Failed to attach Route Mobile credit line for this business':
    'فشل ربط خط ائتمان Route Mobile لهذا النشاط التجاري',
  'A credit line is already attached to this WhatsApp Business Account':
    'يوجد خط ائتمان مرتبط بالفعل بحساب WhatsApp Business هذا',
  'Could not read the WhatsApp Business Account funding status from Meta':
    'تعذر قراءة حالة تمويل حساب WhatsApp Business من Meta',
  'WhatsApp Business Account currency does not match the Route Mobile credit line currency':
    'عملة حساب WhatsApp Business لا تطابق عملة خط ائتمان Route Mobile',
  'Templates go live with your own WhatsApp number. Until then, send with the ready-made sandbox templates.':
    'تُفعَّل القوالب مع رقم واتساب الخاص بك. حتى ذلك الحين، أرسل باستخدام قوالب بيئة الاختبار الجاهزة.',
  'This number has not joined your sandbox. Ask them to scan your sandbox QR code, or connect your own WhatsApp number.':
    'هذا الرقم لم ينضم إلى بيئة الاختبار الخاصة بك. اطلب منه مسح رمز QR الخاص ببيئة الاختبار، أو اربط رقم واتساب الخاص بك.',
  'Your sandbox already has 5 contacts. Remove one to add another, or connect your own WhatsApp number.':
    'يحتوي sandbox الخاص بك بالفعل على 5 جهات اتصال. احذف واحدة لإضافة أخرى، أو اربط رقم واتساب الخاص بك.',
  'This is your sandbox. Add your own number as a new business.':
    'هذه بيئة الاختبار الخاصة بك. أضف رقمك الخاص كنشاط تجاري جديد.',
  'A sandbox campaign can reach at most the phones that joined your sandbox. Add your own WhatsApp number to send to everyone.':
    'يمكن لحملة بيئة الاختبار الوصول فقط إلى الهواتف التي انضمت إلى بيئة الاختبار الخاصة بك. أضف رقم واتساب الخاص بك للإرسال إلى الجميع.',
  'Credit line attached. Your number can send messages now.':
    'تم ربط خط الائتمان. يمكن لرقمك إرسال الرسائل الآن.',
  'Your number is connected, but the credit line could not be attached automatically. Attach it from Settings > Billing & Payments > Attach Credit Line.':
    'رقمك متصل، لكن تعذّر ربط خط الائتمان تلقائيًا. اربطه من الإعدادات > الفوترة والمدفوعات > Attach Credit Line.',
  'Odoo billing is not configured on this server (RML_ODOO_BILLING_API_KEY is not set). Nothing was sent.':
    'فوترة Odoo غير مهيأة على هذا الخادم (لم يتم تعيين RML_ODOO_BILLING_API_KEY). لم يتم إرسال أي شيء.',
};
